import React from "react";
import Select from "react-select";
import { useToken } from "@chakra-ui/react";

/**
 * Dropdown ที่พิมพ์เพื่อกรองรายการได้ ใช้ react-select แต่จัดสไตล์ให้เข้ากับ Input/Select ของ Chakra
 *
 * options : [{ value, label }]
 * value   : ค่า value ที่เลือกอยู่ (string) หรือ "" ถ้ายังไม่เลือก
 * onChange: (value) => void ส่งกลับเฉพาะ value เพื่อให้ใช้แทน Chakra Select ได้ง่าย
 */
const SearchableSelect = ({
  options = [],
  value,
  onChange,
  placeholder = "พิมพ์เพื่อค้นหา...",
  isDisabled = false,
  isInvalid = false,
  name,
  noOptionsMessage = "ไม่พบรายการที่ค้นหา",
}) => {
  const [gray100, gray200, gray400, gray500, red500, blue500, blue50, blue100] =
    useToken("colors", [
      "gray.100",
      "gray.200",
      "gray.400",
      "gray.500",
      "red.500",
      "blue.500",
      "blue.50",
      "blue.100",
    ]);
  const [radiusMd] = useToken("radii", ["md"]);

  const selectedOption =
    options.find((option) => option.value === value) || null;

  const styles = {
    control: (base, state) => ({
      ...base,
      minHeight: "40px",
      borderRadius: radiusMd,
      backgroundColor: isDisabled ? gray100 : "white",
      borderColor: isInvalid
        ? red500
        : state.isFocused
        ? blue500
        : gray200,
      boxShadow: state.isFocused
        ? `0 0 0 1px ${isInvalid ? red500 : blue500}`
        : "none",
      "&:hover": { borderColor: isInvalid ? red500 : gray400 },
    }),
    placeholder: (base) => ({ ...base, color: gray500 }),
    dropdownIndicator: (base) => ({ ...base, color: gray500 }),
    indicatorSeparator: () => ({ display: "none" }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? blue100
        : state.isFocused
        ? blue50
        : "white",
      color: "inherit",
      cursor: "pointer",
    }),
    // ให้ลอยเหนือ Modal/Card ที่มี z-index ของ Chakra
    menuPortal: (base) => ({ ...base, zIndex: 1500 }),
  };

  return (
    <Select
      name={name}
      options={options}
      value={selectedOption}
      onChange={(option) => onChange(option ? option.value : "")}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable
      isSearchable
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      menuPosition="fixed"
      styles={styles}
      noOptionsMessage={() => noOptionsMessage}
      loadingMessage={() => "กำลังโหลด..."}
    />
  );
};

export default SearchableSelect;
